import styled from 'styled-components';
import Calendar from 'react-calendar';
import { Calendar as CalendarIcon } from 'react-feather';

import { colours } from 'themes/default';

export const ManualOverrideContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;

  & > button {
    margin: 8px 0;
    width: fit-content;
  }

  & > div > input {
    width: 100px;
  }
`;

export const ErrorMessage = styled.div`
  color: red;
`;

export const StyledInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 50%;
`;

export const StyledInputWrapper = styled.div`
  width: ${({ isCalendar }) => (isCalendar ? '55%' : '100px')};
`;

export const StyledDateField = styled.div`
  position: relative;

  &:hover {
    cursor: pointer;
  }

  & input:hover {
    cursor: pointer;
  }
`;

export const StyledCalendar = styled(Calendar)`
  &.react-calendar {
    width: 100%;
  }

  .react-calendar__tile-away-dates {
    background-color: ${colours.Shades.BlueShade20};
  }
`;

export const StyledCalendarIcon = styled(CalendarIcon)`
  position: relative;
  right: 32px;
  top: 4px;
`;
